export const dateFormat = 'yyyy-MM-dd'
export const dateDayMonthYearFormat = 'dd/MM/yyyy'
export const dateMonthYearFormat = 'MM/yyyy'
export const dateWithTimeFormat = 'yyyy-MM-dd HH:mm'
export const timeFormat = 'HH:mm'
export const fileNameFormat = 'yyyy-MM-dd-HH-mm'
export const dateFormatMask = '____-__-__'
